export enum TicketDifficultyLevel {
  Easy = "Easy",
  Medium = "Medium",
  Hard = "Hard"
}
